/*
 * Site Video
 **/

/* Video Toggle */

class VideoToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      const video = this.querySelector("video");
      const playButton = this.querySelector("button");

      if (video.paused) {
        console.log("play");
        video.play();
        playButton.style.display = "none";
      } else {
        console.log("pause");
        video.pause();
        playButton.style.display = "grid";
      }
    });
  }
}

customElements.define("video-toggle", VideoToggle);

class SiteVideo extends HTMLElement {
  constructor() {
    super();
    this.video = null;
    this.videoLoaded = false;
    this.autoplay = this.dataset.autoplay == "true";
  }

  connectedCallback() {
    this.video = this.querySelector("video");
    if (this.autoplay) {
      this.observe();
    }
  }

  observe() {
    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((videoEntry) => {
          const video = videoEntry.target;
          if (videoEntry.isIntersecting) {
            if (video.readyState === 4) {
              video.play();
            } else {
              this.load(video);
            }
          } else {
            if (!video.paused) {
              video.pause();
            }
          }
        });
      });

      videoObserver.observe(this.video);
    }
  }

  load(video) {
    if (this.videoLoaded) {
      return;
    }

    [].slice.call(video.querySelectorAll("source")).forEach((source) => {
      source.src = source.dataset.src;
    });
    this.videoLoaded = true;
    video.load();
  }

  play() {
    this.video.play();
    if (!this.autoplay) {
      this.video.controls = true;
    }
  }

  pause() {
    this.video.pause();
  }
}

customElements.define("site-video", SiteVideo);

/*
 * site-image
 **/

class SiteImage extends HTMLElement {
  constructor() {
    super();
    this.observe();
  }

  observe() {
    if ("IntersectionObserver" in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(function (image) {
          const $image = image.target;
          if (image.isIntersecting) {
            $image.classList.add("active");
            imageObserver.unobserve($image);
          }
        });
      });

      imageObserver.observe(this.querySelector(".mediabox"));
    }
  }
}

customElements.define("site-image", SiteImage);

/*
 * Swiper Carousel
 */

class SwiperCarousel extends HTMLElement {
  connectedCallback() {
    this.swiper = null;
    this.id = this.dataset.id;
    this.initCarousel();
  }

  setupListeners() {
    const pagers = this.querySelectorAll(".carousel-pager");
    const prev = this.querySelector(".carousel-prev");
    const next = this.querySelector(".carousel-next");

    if (prev) {
      prev.addEventListener("click", () => {
        if (this.swiper) {
          this.swiper.slidePrev();
        }
      });
    }

    if (next) {
      next.addEventListener("click", () => {
        if (this.swiper.realIndex != pagers.length - 1) {
          if (this.swiper) {
            this.swiper.slideNext();
          }
        }
      });
    }

    Array.from(pagers).forEach((pager, i) => {
      pager.addEventListener("click", (e) => {
        this.swiper.slideTo(i);
      });
    });

    this.swiper.on("slideChange", () => {
      pagers.forEach((el) => el.classList.remove("active"));
      const nextPager = pagers[this.swiper.realIndex];
      if (nextPager) {
        nextPager.classList.add("active");
      }

      if (prev) {
        if (this.swiper.realIndex > 0) {
          prev.removeAttribute("disabled");
        } else {
          prev.setAttribute("disabled", "");
        }
      }

      if (next) {
        if (this.swiper.realIndex === pagers.length) {
          next.setAttribute("disabled", "");
        } else {
          next.removeAttribute("disabled");
        }
      }
    });
  }

  initCarousel() {
    const config = this.data;
    this.swiper = new Swiper(`#${this.id} .swiper`, config);
    this.setupListeners();
  }
}

customElements.define("swiper-carousel", SwiperCarousel);

/*
  Marquee
*/

class MarqueeCarousel extends HTMLElement {
  constructor() {
    super();
    this.setMarquee();
  }

  setMarquee() {
    const speed = 0.2;
    const parentSelector = this.querySelector(".marquee");
    const clone = parentSelector.innerHTML;
    const firstElement = parentSelector.children[0];
    let i = 0;
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);

    setInterval(function () {
      firstElement.style.marginLeft = `-${i}px`;
      if (i > firstElement.clientWidth) {
        i = 0;
      }
      i = i + speed;
    }, 0);
  }
}

customElements.define("marquee-carousel", MarqueeCarousel);

/*
  Before After Slider
*/

class BeforeAfterSlider extends HTMLElement {
  constructor() {
    super();
    this.beforeAfterSlider();
  }

  beforeAfterSlider() {
    const container = this.querySelector(".fifty-fifty__image-container");
    this.querySelector(".fifty-fifty__slider").addEventListener(
      "input",
      (e) => {
        container.style.setProperty("--position", `${e.target.value}%`);
      }
    );
  }
}

customElements.define("before-after-slider", BeforeAfterSlider);

/*
  Fifty Fifty Selectors
*/

class FiftyFiftySelectors extends HTMLElement {
  constructor() {
    super();
    this.fiftyFiftySelectors();
  }

  toDashCase(inputString) {
    return inputString.replace(/\s+/g, "-").toLowerCase();
  }

  fiftyFiftySelectors() {
    const collectionSelectors = this.querySelectorAll(".fiftyfifty__selector");
    const collectionImages = this.querySelectorAll(".fiftyfifty__image-select");

    collectionSelectors.forEach((selector) => {
      selector.addEventListener("click", () => {
        collectionSelectors.forEach((selector) => {
          selector.classList.remove("text-dark-sand");
        });

        selector.classList.add("text-dark-sand");

        collectionImages.forEach((image) => {
          image.classList.add("text-image__image-column--inactive");
          image.classList.remove("text-image__image-column--active");
        });

        let elementId = this.toDashCase(selector.textContent.trim());

        this.querySelector(`#${elementId}`).classList.add(
          "text-image__image-column--active"
        );
      });
    });
  }
}

customElements.define("fiftyfifty-selectors", FiftyFiftySelectors);

/*
  Product Quantity Selector
*/

class ProductQuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.productQuantitySelector();
  }

  productQuantitySelector() {
    const quantityInput = this.querySelector(".quantity");
    const quantityMinus = this.querySelector(".quantity-minus");
    const quantityPlus = this.querySelector(".quantity-plus");

    quantityMinus.addEventListener("click", function () {
      if (parseInt(quantityInput.value) > 1) {
        quantityInput.value = parseInt(quantityInput.value) - 1;
      }
    });

    quantityPlus.addEventListener("click", function () {
      quantityInput.value = parseInt(quantityInput.value) + 1;
    });

    this.querySelector(".quantity").addEventListener("change", function () {
      document.querySelector('input[name="quantity"]').value = this.value;
    });
  }
}

customElements.define("product-quantity-selector", ProductQuantitySelector);

/*
  Accordion Selectors
*/

class AccordionSelectors extends HTMLElement {
  constructor() {
    super();
    this.accordionSelectors();
  }

  accordionSelectors() {
    const accordionSelectors = this.querySelectorAll(".accordion-sections");
    accordionSelectors.forEach((accordionSelector) => {
      accordionSelector.addEventListener("click", function (event) {
        const allArrows = this.querySelectorAll("svg");
        allArrows.forEach((arrow) => {
          arrow.classList.remove("accordion__selector--active");
        });
        this.querySelector("svg").classList.add("accordion__selector--active");
      });
    });
  }
}

customElements.define("accordion-selectors", AccordionSelectors);

/*
 Request Info Modal
 */

class RequestInfoModal extends HTMLElement {
  constructor() {
    super();
    this.modalOpenClose();
  }

  modalOpenClose() {
    const requestBtn = this.querySelector(".request-info__button");
    const closeBtn = this.querySelector(".modal-close_btn");
    const modal = this.querySelector(".info-modal__container");
    const newModal = this.querySelector(".modal");

    requestBtn.addEventListener("click", () => {
      if (modal) {
        if (modal.classList.contains("hidden")) {
          modal.classList.replace("opacity-0", "opacity-100");
          modal.classList.replace("hidden", "flex");
        }
      }
      if (newModal) {
        newModal.classList.add("active");
      }
    });

    closeBtn.addEventListener("click", () => {
      if (modal) {
        if (modal.classList.contains("flex")) {
          modal.classList.replace("opacity-100", "opacity-0");
          modal.classList.replace("flex", "hidden");
        }
      }
      if (newModal) {
        newModal.classList.remove("active");
      }
    });

    var keys = {
      37: 1,
      38: 1,
      39: 1,
      40: 1,
    };
    function preventDefault(e) {
      e.preventDefault();
    }

    function preventDefaultForScrollKeys(e) {
      if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
      }
    }
    let supportsPassive = false;
    try {
      window.addEventListener(
        "test",
        null,
        Object.defineProperty({}, "passive", {
          get: function () {
            supportsPassive = true;
          },
        })
      );
    } catch (e) {}

    let wheelOpt = supportsPassive
      ? {
          passive: false,
        }
      : false;
    let wheelEvent =
      "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

    function disableScroll() {
      window.addEventListener("DOMMouseScroll", preventDefault, false);
      window.addEventListener(wheelEvent, preventDefault, wheelOpt);
      window.addEventListener("touchmove", preventDefault, wheelOpt);
      window.addEventListener("keydown", preventDefaultForScrollKeys, false);
    }

    function enableScroll() {
      window.removeEventListener("DOMMouseScroll", preventDefault, false);
      window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
      window.removeEventListener("touchmove", preventDefault, wheelOpt);
      window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
    }

    function scrollToTop() {
      window.scrollTo(0, 0);
    }
  }
}

customElements.define("request-info-modal", RequestInfoModal);

/*
 Acerill Modal
 */

class AcerillModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const requestBtn = this.querySelector(".acerill-open");
    const closeBtn = this.querySelector(".modal-close_btn");
    const modal = this.querySelector(".acerill__container");

    requestBtn.addEventListener("click", () => {
      if (modal.classList.contains("hidden")) {
        modal.classList.replace("opacity-0", "opacity-100");
        modal.classList.replace("hidden", "flex");
      }
    });

    closeBtn.addEventListener("click", () => {
      if (modal.classList.contains("flex")) {
        modal.classList.replace("opacity-100", "opacity-0");
        modal.classList.replace("flex", "hidden");
      }
    });
  }
}

customElements.define("acerill-modal", AcerillModal);

/*
Register Form Loader
*/

class FormLoader extends HTMLElement {
  constructor() {
    super();
    this.checkLoad();
  }
  checkLoad() {
    const loader = this.querySelector(".loader-icon");
    const formContainer = this.querySelector(".form-container");
    formContainer.classList.add("hidden");
    setTimeout(() => {
      if (formContainer.hasChildNodes()) {
        loader.classList.add("hidden");
        formContainer.classList.remove("hidden");
      } else {
        loader.classList.remove("hidden");
        formContainer.classList.add("hidden");
      }
    }, 400);
  }
}
customElements.define("form-loader", FormLoader);

/*
FAQs
*/

class Faqs extends HTMLElement {
  constructor() {
    super();
    this.renderAnswer();
  }
  renderAnswer() {
    const question = this.querySelector(".faqs__item");
    const container = this.querySelector(".faqs__item-container");
    const answer = this.querySelector(".faqs__answer");

    question.addEventListener("click", () => {
      container.classList.toggle("active");

      if (container.classList.contains("active")) {
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        answer.style.maxHeight = "0";
      }
    });
  }
}
customElements.define("question-answer", Faqs);

/*
 Search Form
 */

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.renderBar();
  }
  renderBar() {
    const bar = this.querySelector(".search_form");
    const openBtn = this.querySelector(".search-button");
    const closeBtn = this.querySelector(".search-close");
    const input = bar.querySelector('input[type="text"]');

    if (openBtn) {
      openBtn.addEventListener("click", () => {
        bar.classList.remove("opacity-0");
        bar.classList.remove("invisible");
        setTimeout(() => {
          input.focus();
        }, 50);
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        bar.classList.add("opacity-0");
        bar.classList.add("invisible");
        setTimeout(() => {
          input.blur();
        }, 50);
      });
    }
  }
}
customElements.define("search-form", SearchForm);

/*
Site Modal
*/

class SiteModal extends HTMLElement {
  constructor() {
    super();
    this.autoOpenTimeout = this.dataset.autoOpenTimeout;
  }

  openModal() {
    document.body.style.overflow = "hidden";
    this.querySelector(".modal").classList.add("active");
  }

  closeModal() {
    document.body.removeAttribute("style");
    this.querySelector(".modal").classList.remove("active");

    if (this.autoOpenTimeout) {
      localStorage.setItem("newsletter", "true");
    }
  }

  connectedCallback() {
    const opens = this.querySelectorAll(".modal-open");
    const closes = this.querySelectorAll(".modal-close");

    Array.from(opens).forEach((open) => {
      open.addEventListener("click", (e) => {
        this.openModal();
      });
    });

    Array.from(closes).forEach((close) => {
      close.addEventListener("click", (e) => {
        this.closeModal();
      });
    });

    if (this.autoOpenTimeout) {
      setTimeout(() => {
        if (!localStorage.getItem("newsletter")) {
          this.openModal();
        }
      }, this.autoOpenTimeout);
    }
  }
}
customElements.define("site-modal", SiteModal);

/*
Accordion Item
*/

class AccordionItem extends HTMLElement {
  constructor() {
    super();
    this.renderAnswer();
  }
  renderAnswer() {
    const arrow = this.querySelector("svg");
    const trigger = this.querySelector("button");
    const container = this.querySelector(".accordion-item");
    const content = this.querySelector(".accordion-content");

    trigger.addEventListener("click", () => {
      container.classList.toggle("active");

      if (container.classList.contains("active")) {
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.style.maxHeight = "0";
      }
    });
  }
}
customElements.define("accordion-item", AccordionItem);

/*
Summit Signup
*/

class SummitSignup extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.atcBlockerText = this.dataset.atcBlockerText;
    this.atcButton = null;
    this.atcRow = null;
  }

  connectedCallback() {
    this.atcButton = document.querySelector("#add-to-cart-js");
    this.atcRow = document.querySelector(".pdp__atc-row");

    if (localStorage.getItem("he-summit-signup")) {
      this.enableATC();
    } else {
      this.disableATC();
    }

    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.handleSubmit();
    });
  }

  enableATC() {
    this.atcButton.disabled = false;
    this.atcRow.querySelector("p").remove();
  }

  disableATC() {
    this.atcButton.disabled = true;
    const el = document.createElement("p");
    el.className =
      "font-roobert-bold uppercase text-xs py-4 px-2 text-center rounded-lg lg:rounded-xl block col-span-12 lg:col-span-10 xl:col-span-9 border border-black";
    el.textContent = this.atcBlockerText;
    this.atcRow.appendChild(el);
  }

  async handleSubmit() {
    const submit = this.querySelector('[type="submit"]');
    const submitText = submit.innerHTML;
    const formData = new FormData(this.form);
    const formDataObj = {};
    formData.forEach(function (value, key) {
      formDataObj[key] = value;
    });

    submit.innerHTML = "Submitting...";

    try {
      const signup = await fetch(
        "https://hunni-serverless.vercel.app/api/harper-ellis/summit-signup",
        {
          method: "POST",
          body: JSON.stringify(formDataObj),
        }
      );
      const resp = await signup.json();
      this.querySelector("p.success").classList.remove("hidden");
      localStorage.setItem("he-summit-signup", "true");
      this.enableATC();
      this.form.reset();
    } catch (e) {
      this.querySelector("p.error").classList.remove("hidden");
    }

    submit.innerHTML = submitText;
  }
}

customElements.define("summit-signup", SummitSignup);
